import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";

export function useGetReportingMeasurementsByResultCapture(
  captureId: number,
  customerId: number,
  switchGearAssetId: number,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["reportingMeasurements", captureId, customerId, switchGearAssetId],
    queryFn: async () => {
      return apiContext.utp2ReportsAPIs
        .getReportMeasurementSelectionsByResultCapture(captureId, customerId, switchGearAssetId)
        .then((response) => {
          return response;
        });
    },
  });
}
